module.exports = __webpack_public_path__ + "static/media/io.e1798dab.svg";